module.exports = __webpack_public_path__ + "static/media/01_A5_-01.56c2fa69.png";